import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-wtaetigkeit-list-view',
  imports: [],
  templateUrl: './wtaetigkeit.list-view.html',
  styleUrls: ['./wtaetigkeit.list-view.css'],
})
export class WtaetigkeitListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
